<template>
  <div class="text-center">
    <div class="h-16">
      <strong>
        {{ titleToDisplay }}
      </strong>
    </div>

    <component
      :is="containerElement"
      ref="baieSvg"
      class="full-baie mx-auto"
    >
      <component
        :is="svgs[element.name]"
        v-for="element in elements"
        :key="element.position"
        :width="elementWidth"
        :x="containerOffsets.leftOffset"
        :y="containerOffsets.firstElementTopOffset + uSizeInPixels * element.position"
        :class="{selected: element.isSelected}"
        @mouseenter="displayElementTitle(element)"
        @mouseleave="displayDefaultTitle()"
        @click="$emit('selectElement', element)"
      />
    </component>
  </div>
</template>

<script>
import { chain, capitalize, every } from 'lodash';
import Baie42U from './baie_components/baie-42U.vue';
import Baie37U from './baie_components/baie-37U.vue';
import Baie27U from './baie_components/baie-27U.vue';
import Baie22U from './baie_components/baie-22U.vue';
import Coffret6U from './baie_components/coffret-6U.vue';
import Coffret9U from './baie_components/coffret-9U.vue';
import Coffret12U from './baie_components/coffret-12U.vue';
import Coffret15U from './baie_components/coffret-15U.vue';
import Coffret18U from './baie_components/coffret-18U.vue';
import Coffret22U from './baie_components/coffret-22U.vue';

import { BAIE, COFFRET } from '../constants';
import { imageNameForProduct } from '../store/helpers';

const DEFAULT_TITLE_TO_DISPLAY = 'Passez votre souris sur un élément pour avoir des détails';

export default {
  name: 'TheBaie',
  components: {
    Baie42U,
    Baie37U,
    Baie27U,
    Baie22U,
    Coffret6U,
    Coffret9U,
    Coffret12U,
    Coffret15U,
    Coffret18U,
    Coffret22U,
  },
  props: {
    elements: {
      type: Array,
      required: true,
      validator: (value) => every(value, 'name') && every(value, 'position'),
    },
    container: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      uSizeInPixels: 127,
      elementWidth: 1370,
      titleToDisplay: DEFAULT_TITLE_TO_DISPLAY,
    };
  },
  computed: {
    svgs() {
      const componentsContext = require.context('@/components/baie_components', false, /\.svg/i);
      const components = {};
      componentsContext.keys().forEach((x) => {
        const pascalCaseKey = chain(x.split('/')[1].split('.')[0]).words().map(capitalize).join('')
          .value();
        components[pascalCaseKey] = componentsContext(x);
      });
      return components;
    },
    containerElement() {
      if (this.container) {
        const defaultContainerSvg = this.containerType === BAIE ? 'Baie42U' : 'Coffret22U';
        return imageNameForProduct(this.container, defaultContainerSvg);
      }
      return 'Baie42U';
    },
    containerType() {
      let result = BAIE;
      if (this.container) {
        result = this.container.productable_type;
      }
      return result;
    },
    containerOffsets() {
      return {
        [BAIE]: {
          firstElementTopOffset: 126.14,
          leftOffset: 370,
        },
        [COFFRET]: {
          firstElementTopOffset: 100,
          leftOffset: 302,
        },
      }[this.containerType];
    },
  },
  methods: {
    uSize(elementName) {
      const numberOfUs = elementName.match(/\dU/i);
      if (numberOfUs) {
        return parseInt(numberOfUs[0], 10);
      }
      return 1;
    },
    displayElementTitle(element) {
      this.titleToDisplay = element.title;
    },
    displayDefaultTitle() {
      this.titleToDisplay = DEFAULT_TITLE_TO_DISPLAY;
    },
  },
};
</script>

<style lang="scss" scoped>
svg {
  overflow: visible;
}

.selected {
  fill: none;
  stroke: yellow;
  stroke-width: 10px;
  stroke-linejoin: round;
}

.full-baie {
  height: calc(100% - 64px);
}
</style>
